import { ResponseData, Err } from 'types';

import { http } from '.';

export const uploadFile = async (file: File, type: number) => {
  const formData = new FormData();
  formData.append('file', file);
  return await http.post<Err, ResponseData<any[]>>(
    `/IO/UploadFile?fileFolderForSaving=${type}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};
